var UploaderService = {
  props: {
    service: { default: false },
    endpoint: { default: '/servicios/archivos/' },
  },

  data: function () {
    return {
      file: false,
      loading: false,
      uploader: false,
      progress: 0,
    };
  },

  computed: {},

  watch: {
    service: function (value) {
      this.uploader.params.service = value;
    },
  },

  mounted: function () {
    this.uploader = UIkit.upload(this.$el, {
      type: 'json',
      name: 'file',
      url: this.endpoint,
      multiple: false,
      //maxSize: 2048,
      allow: '*.(jpg|jpeg|png|gif)',
      params: {
        service: this.service,
      },

      i18n: UIkitUploadI18n,

      beforeAll: (uploader, files) => {
        //console.log('uploader.beforeAll', uploader, files);
      },
      beforeSend: async (env) => {
        let file = env.data.get('file');

        //console.log(file);
        if (file.type === 'image/jpeg' || file.type === 'image/x-png') {
          file = await resizeImage(file);
        }

        if (file.size > 2 * 1024 * 1024) {
          throw new Error(UIkitUploadI18n.invalidSize);
        }

        env.data.set('file', file);
      },
      loadStart: (e) => {
        //console.log('start', e);
      },
      progress: (e) => {
        this.progress = Math.round((100 * e.loaded) / e.total);
        //console.log('progress', e, this.progress);
      },
      loadEnd: (e) => {
        this.progress = 0;
        //console.log('end', e);
      },
      error: (e) => {
        this.progress = 0;
        let error = e.message;
        switch (e.status) {
          case 413:
            error = UIkitUploadI18n.invalidSize;
        }
        customAlert('Ha ocurrido un error', error);
        console.error(e);
      },
      fail: (e) => {
        customAlert('Ha ocurrido un error', e);
      },
      complete: (xhr) => {
        //console.log('complete', xhr);
        this.$emit('append', xhr.response);
      },
    });
  },

  methods: {},

  template: `
      <div uk-form-custom>
	      <input type="file" accept="image/*">
	      <button class="uk-button uk-button-ghost uk-button-primary" type="button" tabindex="-1">
	        Añadir imagen
	      </button>
      </div>
	`,
};
